import {
  GET_CONTACT_DETAILS,
  NO_CONTACT_FOUND,
  SHOW_ADD_CONTACT,
  SHOW_CREATE_TICKET,
} from "../Types/ContactTypes";
const contactState = {
  getContactDetails: true,
  noContactFound: false,
  showAddContact: false,
  showCreateTicket: false,
};

export const contactReducer = (state = contactState, action) => {
  const { payload, type } = action;

  // This reducer is only used to trigger getContactDetails after editing contact
  if (type === GET_CONTACT_DETAILS) {
    return {
      ...state,
      getContactDetails: !state.getContactDetails,
    };
  }

  // For inbound call create new contact
  if (type === SHOW_ADD_CONTACT) {
    return {
      ...state,
      showAddContact: payload,
    };
  }

  // For inbound call save ticket
  if (type === SHOW_CREATE_TICKET) {
    return {
      ...state,
      showCreateTicket: payload,
    };
  }

  // For inbound call new contact
  if (type === NO_CONTACT_FOUND) {
    return {
      ...state,
      noContactFound: payload,
    };
  }

  return state;
};
